import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "selectedTags",
    "searchInput",
    "options",
    "loading",
    "noResults",
    "list"
  ]

  connect() {
    this.isOpen = false;
    this.selectedIds = new Set();
    this.availableItems = [];
    this.searchTerm = "";
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.optionsTarget.style.display = 'block';
    this.searchInputTarget.focus();

    // Trigger search in parent controller
    this.dispatch('open', { detail: { controller: this } });
  }

  close() {
    this.isOpen = false;
    this.optionsTarget.style.display = 'none';
    this.searchInputTarget.value = '';
    this.searchTerm = '';
  }

  search(event) {
    this.searchTerm = event.target.value;
    this.dispatch('search', { detail: { searchTerm: this.searchTerm } });
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  toggleItem(event) {
    const itemId = event.currentTarget.dataset.itemId;
    this.dispatch('toggleItem', { detail: { itemId } });
  }

  removeTag(event) {
    event.stopPropagation();
    const itemId = event.currentTarget.dataset.itemId;
    this.dispatch('removeTag', { detail: { itemId } });
  }

  // Handle clicks outside the dropdown
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }
}

